import { Model } from "@vuex-orm/core";
import shortid from "shortid";
import moment from "moment";

export default class CompanyAddress extends Model {
  static entity = "companyAddresses";
  static fields() {
    return {
      id: this.attr("tmp/" + shortid.generate()),
      companyId: this.attr(null),
      description: this.attr(null),
      addressId: this.attr(null),
      name: this.attr(null),
      number: this.attr(null),
      complement: this.attr(null),
      lat: this.attr(null),
      lng: this.attr(null),
      dateUpdated: this.attr(null),
      dateCreated: this.attr(moment().toISOString()),
      dateRemoved: this.attr(null),
      status: this.attr('active')
    }
  }

}
